import * as React from "react"
import type { SVGProps } from "react"
const SvgParagraphSpacing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 8.14 4.1 9a1 1 0 0 1-.69.28 1 1 0 0 1-.71-.3 1 1 0 0 1-.28-.7q0-.43.28-.7l2.6-2.6q.14-.15.32-.22a1 1 0 0 1 .75 0A1 1 0 0 1 6.7 5l2.6 2.6q.27.27.29.68A1 1 0 0 1 9.3 9a1 1 0 0 1-.69.28 1 1 0 0 1-.71-.26L7 8.14v8.3l.9-.88a1 1 0 0 1 .69-.27q.4 0 .71.3a1 1 0 0 1 .28.7 1 1 0 0 1-.28.7l-2.6 2.6q-.14.15-.32.2a1 1 0 0 1-.38.07 1 1 0 0 1-.37-.06 1 1 0 0 1-.33-.21l-2.6-2.6a1 1 0 0 1-.29-.7 1 1 0 0 1 .29-.7 1 1 0 0 1 .69-.3 1 1 0 0 1 .71.27l.9.88zm8 11.15a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72a1 1 0 0 1 .71-.28h8a.97.97 0 0 1 1 1q0 .43-.29.7a1 1 0 0 1-.71.3zm0-6a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72a1 1 0 0 1 .71-.28h8a.97.97 0 0 1 1 1q0 .43-.29.7a1 1 0 0 1-.71.3zm0-6a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72A1 1 0 0 1 13 5.3h8a.97.97 0 0 1 1 1q0 .43-.29.7a1 1 0 0 1-.71.3z" />
  </svg>
)
export default SvgParagraphSpacing
